import styled, { css } from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { ChevronIcon } from '@/components/UI/Icons/Icons';
import { Checkbox } from '@/components/UI/Checkbox/Checkbox';

const selectedSubcategoryStyles = css`
  background: ${({ theme }) => theme.palette.secondary.background};
  & label {
    color: ${({ theme }) => theme.palette.brand.main};
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  min-height: 0;

  ::-webkit-scrollbar {
    width: 4px;
  }

  ::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.palette.primary.border};
    border-radius: 7px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.palette.tertiary.labels};
    border-radius: 7px;
  }
`;

export const Box = styled.div`
  padding: 15px;
  border: 1px solid ${({ theme }) => theme.palette.secondary.border};
  border-radius: 14px;
  min-height: 0;
`;

export const CategoryItemsWrapper = styled.div`
  display: flex;
  gap: 5px;
  min-height: 0;
  max-height: 100%;
`;

export const SubcategoryItems = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 5px;
  overflow-y: auto;
  min-height: 0;
`;

export const CategoryItems = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 330px;
  gap: 5px;
  overflow-y: auto;
  min-height: 0;
  padding-right: 10px;
  border-right: 1px solid ${({ theme }) => theme.palette.secondary.border};
`;

export const CategoryItem = styled.div<{ $isSelected: boolean }>`
  display: flex;
  align-items: center;
  gap: 15px;
  min-height: 50px;
  width: 100%;
  padding: 0 15px;
  background: ${({ theme }) => theme.palette.primary.background};
  border-radius: 14px;
  user-select: none;
  cursor: pointer;

  ${({ $isSelected }) =>
    $isSelected &&
    css`
      background: ${({ theme }) => theme.palette.secondary.background};
      color: ${({ theme }) => theme.palette.brand.main};

      & svg {
        color: ${({ theme }) => theme.palette.brand.main};
      }
    `}

  img {
    object-fit: contain;
  }
`;

export const CategoryItemIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
`;

export const SubcategoryItem = styled(Checkbox)<{ value: boolean }>`
  min-height: 50px;
  border-bottom: none;
  padding: 0 15px;
  background: ${({ theme }) => theme.palette.primary.background};
  border-radius: 14px;
  user-select: none;
  cursor: pointer;

  & label {
    cursor: pointer;
    font-size: 16px;
  }

  ${({ value }) => value && selectedSubcategoryStyles}

  &:hover {
    ${selectedSubcategoryStyles}
  }
`;

export const SubcategoryFilteredItem = styled(SubcategoryItem)`
  height: unset;
  padding: 10px 15px;
`;

export const SubcategoryCustomContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 10px;

  img {
    object-fit: contain;
  }
`;

export const SubcategoryCustomInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  gap: 5px;
`;

export const CategoryLabel = styled(Typography.Text)`
  width: 100%;
`;

export const CategoryChevronIcon = styled(ChevronIcon)`
  width: 35px;
  height: 35px;
  transform: rotate(180deg);
  color: ${({ theme }) => theme.palette.secondary.labels};
`;
